import { attentionListSchema } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';
import type { AttentionList } from '../../model/attention.js';
import type { AttentionListDto } from '../dto/attention.dto.js';
import { toAttentionList } from '../mappers/attention.mapper.js';

const fetchAttention = async (signal: AbortSignal): Promise<AttentionListDto> =>
  attentionListSchema.parse(await apiRequest<unknown>('/attention', { signal }));

export const getAttention = async (signal: AbortSignal): Promise<AttentionList> =>
  toAttentionList(await fetchAttention(signal));
